// extracted by mini-css-extract-plugin
module.exports = {"container":"FetchCreateSelect_container__2I9tQ"};